import React, { useEffect, useState } from 'react'
import './RecipeRenameModal.css'

function RecipeRenameModal({
  isOpen,
  onClose,
  initialName,
  onConfirm,
  saving = false,
}) {
  const [recipeName, setRecipeName] = useState(initialName || '')

  useEffect(() => {
    if (isOpen && initialName) {
      setRecipeName(initialName)
    }
  }, [isOpen, initialName])

  useEffect(() => {
    function handleEscape(e) {
      if (e.key === 'Escape' && isOpen && !saving) {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      return () => document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, onClose, saving])

  function handleConfirm() {
    if (recipeName.trim() && !saving) {
      onConfirm(recipeName.trim())
    }
  }

  function handleKeyPress(e) {
    if (e.key === 'Enter' && recipeName.trim() && !saving) {
      e.preventDefault()
      handleConfirm()
    }
  }

  if (!isOpen) {
    return null
  }

  return (
    <div
      className="modal-overlay recipe-rename-modal-overlay"
      onClick={saving ? undefined : onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="recipe-rename-title"
    >
      <div
        className="card recipe-rename-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="recipe-rename-modal-header">
          <h2 id="recipe-rename-title" className="recipe-rename-modal-title">
            <i className="fas fa-utensils recipe-rename-modal-title-icon" aria-hidden="true" />
            <span>Save imported recipe</span>
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="ghost recipe-rename-modal-close"
            disabled={saving}
            aria-label="Close rename modal"
          >
            ×
          </button>
        </div>

        <div className="recipe-rename-modal-body">
          <label htmlFor="recipe-rename-input" className="recipe-rename-modal-label">
            Recipe name
          </label>
          <input
            id="recipe-rename-input"
            type="text"
            className="input recipe-rename-modal-input"
            value={recipeName}
            onChange={(e) => setRecipeName(e.target.value)}
            onKeyDown={handleKeyPress}
            placeholder="e.g., Chicken Parmesan"
            disabled={saving}
            aria-label="Recipe name input"
          />
          <p className="recipe-rename-modal-hint">
            Ingredients will be saved to your recipe collection and added to your shopping list.
          </p>
        </div>

        <div className="recipe-rename-modal-actions">
          <button
            type="button"
            onClick={onClose}
            className="secondary"
            disabled={saving}
            aria-label="Cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={!recipeName.trim() || saving}
            className={recipeName.trim() && !saving ? 'primary' : ''}
            aria-label="Save recipe and add ingredients to shopping list"
          >
            {saving ? (
              <>
                <i className="fas fa-spinner fa-spin" aria-hidden="true" /> Saving…
              </>
            ) : (
              'Save & add to list'
            )}
          </button>
        </div>
      </div>
    </div>
  )
}

export default RecipeRenameModal
